import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid, Hidden } from '@mui/material';
import { MarketInputText } from '@market/react';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import ControlledCheckbox from 'components/common/forms/controlled_checkbox';
import {
  BIRTHDATE_REGEX,
  CREDITSAFE_PATTERNS,
  POSTAL_CODE_REGEX_BY_COUNTRY,
} from 'constants/patterns';
import { buildLegalLink } from 'utilities/links';

const Fields = (props) => {
  const { applicationData, disabled } = props;
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Hidden implementation="css" xsUp>
        <Grid item xs={12} md={6}>
          <ControlledInputText
            label="First name"
            name="personal_first_name"
            control={control}
            maxlength={30}
            rules={{
              required: true,
              maxLength: 30,
              pattern: CREDITSAFE_PATTERNS.name,
            }}
            disabled
            defaultValue={
              applicationData.personal_first_name.replaceAll(/[^\w ]/g, '') ||
              ''
            }
            autocomplete="given-name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledInputText
            label="Last name"
            name="personal_last_name"
            control={control}
            maxlength={30}
            rules={{
              required: true,
              maxLength: 30,
              pattern: CREDITSAFE_PATTERNS.name,
            }}
            disabled
            defaultValue={
              applicationData.personal_last_name.replaceAll(/[^\w ]/g, '') || ''
            }
            autocomplete="family-name"
          />
        </Grid>
      </Hidden>
      {/* this is a placeholder element!*/}
      <Grid item xs={7}>
        <MarketInputText
          name="account_holder_name"
          readonly
          value={[
            applicationData.personal_first_name,
            applicationData.personal_last_name,
          ].join(' ')}
          disabled
        >
          <label>Account holder name</label>
        </MarketInputText>
      </Grid>
      <Grid item xs={5}>
        <ControlledInputText
          label="Date of birth"
          name="personal_birthdate"
          control={control}
          disabled={disabled}
          maxlength={10}
          rules={{
            required: true,
            pattern: BIRTHDATE_REGEX,
            maxLength: 10,
          }}
          defaultValue={applicationData.personal_birthdate || ''}
          placeholder="YYYY-MM-DD"
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledInputText
          label="Home address line 1"
          name="personal_street_1"
          control={control}
          disabled={disabled}
          placeholder="123 Easy Street"
          maxlength={50}
          rules={{
            required: true,
            pattern: CREDITSAFE_PATTERNS.street,
            maxLength: 50,
          }}
          defaultValue={applicationData.personal_street_1 || ''}
          autocomplete="address-line1"
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledInputText
          label="Home address line 2"
          name="personal_street_2"
          control={control}
          disabled={disabled}
          placeholder="Optional"
          maxlength={50}
          rules={{
            pattern: CREDITSAFE_PATTERNS.street,
            maxLength: 50,
          }}
          defaultValue={applicationData.personal_street_2 || ''}
          autocomplete="address-line2"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label="Town/City"
          name="personal_city"
          defaultValue={applicationData.personal_city || ''}
          control={control}
          disabled={disabled}
          maxlength={35}
          rules={{
            required: true,
            maxLength: 35,
            pattern: CREDITSAFE_PATTERNS.city_state,
          }}
          autocomplete="address-level2"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label="County"
          name="personal_state_province"
          disabled={disabled}
          defaultValue={applicationData.personal_state_province || ''}
          control={control}
          maxlength={35}
          rules={{
            required: true,
            maxLength: 35,
            pattern: CREDITSAFE_PATTERNS.city_state,
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label="Postcode"
          name="personal_postal_code"
          disabled={disabled}
          defaultValue={applicationData.personal_postal_code || ''}
          control={control}
          maxlength={8}
          rules={{
            required: true,
            maxLength: 8,
            pattern: POSTAL_CODE_REGEX_BY_COUNTRY.GB,
          }}
          placeholder="XX00 0XX"
          autocomplete="postal-code"
        />
      </Grid>
      <Grid item xs={12} md={12} mb={2}>
        <ControlledCheckbox
          name="accepted_legal_agreements"
          control={control}
          disabled={disabled}
          label={
            <div
              dangerouslySetInnerHTML={{
                __html: t('checkout.financeApp.legal_agreement_html', {
                  privacyLink: buildLegalLink('/privacy'),
                  esignLink: buildLegalLink('/sign'),
                  creditLink: buildLegalLink('/shop-credit-authorization'),
                }),
              }}
            />
          }
          defaultValue={applicationData.accepted_legal_agreements || false}
          rules={{ required: true }}
        />
      </Grid>
    </>
  );
};

export default Fields;
